import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { FileText, Mail } from 'lucide-react';
import './Legal.css';

export default function Terms() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('pt') ? 'pt' : 'en';
  const { t } = useTranslation('terms', { lng: lang });
  const sections = t('sections', { returnObjects: true });

  return (
    <div className="legal-page">
      <Helmet>
        <title>Termos de Uso — Libben Agents</title>
        <meta name="description" content="Termos de Uso da plataforma Libben Agents. Leia sobre planos, privacidade, uso aceitável e seus direitos." />
        <link rel="canonical" href="https://libbenagents.com/terms" />
        <meta property="og:title" content="Termos de Uso — Libben Agents" />
        <meta property="og:url" content="https://libbenagents.com/terms" />
      </Helmet>
      <div className="legal-glow" />
      <div className="legal-container">
        <div className="legal-header">
          <FileText size={28} className="legal-icon" />
          <h1 className="legal-title">{t('pageTitle')}</h1>
          <div className="legal-meta">
            <span className="legal-badge">{t('version')}</span>
            <span className="legal-date">{t('lastUpdated')}</span>
          </div>
        </div>

        <div className="legal-sections">
          {Array.isArray(sections) && sections.map((section, i) => (
            <div key={i} className="legal-section">
              <h2 className="legal-section-title">{section.title}</h2>
              <p className="legal-section-text">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="legal-contact">
          <h3 className="legal-contact-title">{t('contact.title')}</h3>
          <div className="legal-contact-grid">
            <a href="mailto:suporte@libben.com.br" className="legal-contact-item">
              <Mail size={14} />
              <span>{t('contact.support')}</span>
              <strong>suporte@libben.com.br</strong>
            </a>
            <a href="mailto:privacidade@libben.com.br" className="legal-contact-item">
              <Mail size={14} />
              <span>{t('contact.privacy')}</span>
              <strong>privacidade@libben.com.br</strong>
            </a>
            <a href="mailto:financeiro@libben.com.br" className="legal-contact-item">
              <Mail size={14} />
              <span>{t('contact.billing')}</span>
              <strong>financeiro@libben.com.br</strong>
            </a>
          </div>
        </div>

        <p className="legal-footer">{t('copyright')}</p>
      </div>
    </div>
  );
}
